import React from 'react';
import { View } from 'react-native-web';
import CustomText from '../../../../components/atoms/CustomText';
import { colors, spacing } from '../../../../utils/styling';

// 2026-08-20 (McKayla Loom "Nitrogen Layout Part 1" t=3:51 → F19, ClickUp 86bah7dqn).
// A DELIBERATE placeholder, and it should stay one until she says what a
// check-in is. Verbatim: "Check-ins, I kind of like the idea of a check-in
// page. So, maybe just put it as a blank page for now. I have no idea what
// that would look like, but I like the idea of that."
//
// Do not guess the feature. Plan question Q6 is open: a check-in could be a
// scheduling tool, a re-take prompt, or a note log, and those are three
// different builds. The point of this shell is that she can look at it in the
// product and tell us which.
export default function CheckInsTab() {
  return (
    <View style={styles.content}>
      <View style={styles.card}>
        <CustomText style={styles.sectionTitle}>Check-ins</CustomText>
        <CustomText style={styles.body}>
          This is where client check-ins will live. It is intentionally empty while we decide
          what a check-in should do.
        </CustomText>
      </View>
    </View>
  );
}

const styles = {
  content: {
    padding: spacing.xl,
    maxWidth: 1200,
    marginHorizontal: 'auto',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  } as React.CSSProperties,
  card: {
    backgroundColor: colors.white,
    borderRadius: 8,
    padding: spacing.xl,
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: colors.dark,
  },
  body: {
    marginTop: spacing.sm,
    fontSize: 14,
    color: colors.gray[700],
  },
} as const;
